import './buttons.scss'

import { register } from 'tmr/tmr/ngModuleRegistry'

import * as toolbarButton from './toolbarButton/toolbarButton'

export default register('tmr.core.components.buttons', toolbarButton)
